import { render, staticRenderFns } from "./PanelAidedDesign.vue?vue&type=template&id=6c422931&scoped=true"
import script from "./PanelAidedDesign.vue?vue&type=script&lang=js"
export * from "./PanelAidedDesign.vue?vue&type=script&lang=js"
import style0 from "./PanelAidedDesign.vue?vue&type=style&index=0&id=6c422931&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c422931",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c422931')) {
      api.createRecord('6c422931', component.options)
    } else {
      api.reload('6c422931', component.options)
    }
    module.hot.accept("./PanelAidedDesign.vue?vue&type=template&id=6c422931&scoped=true", function () {
      api.rerender('6c422931', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/PanelAidedDesign.vue"
export default component.exports